/**
 * Floating search
 */

//import { PostsPagination } from './modules/posts-pagination.js';

class FloatingSearch {
    constructor() {
        this.searchForm = $('#floating-searchform');
        this.searchOverlay = $('#floating-searchbar .search-overlay');
        this.searchResults = $('#floating-searchbar .search-overlay > .results');
        this.actionBox = $('#floating-searchbar .search-overlay > .actions');
        this.searchField = $('#floating-searchbar input.floating-search-input');
        this.searchButton = $('#floating-searchbar .search-form');
        this.isOverlayOpen = false;
        this.isSpinnerVisible = false;
        this.root = $(document);
        this.previousValue;
        this.min_search_length = 2;
        this.typingTimer;

        this.init();
        this.events();
    }

    init() {
        $ = jQuery;

        let floatingSearchBar = document.getElementById('floating-searchbar');
        let headerContainer = document.querySelector('.site-header');

        if (!floatingSearchBar) {
            return false;
        }

        let searchTriggers = document.querySelectorAll('[data-trigger="floating-search"], .close-searchform');

        for (let element of searchTriggers) {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                floatingSearchBar.classList.toggle('open');
                this.searchField.focus();
                this.closeOverlay();
            });
        }

        window.addEventListener('click', function (e) {
            if (headerContainer.contains(e.target)) {
                return false;
            }

            if (floatingSearchBar.classList.contains('open')) {
                floatingSearchBar.classList.remove('open');
            }
        });

        this.searchField.val('');
    }

    // Ajax part

    // events
    events() {
        var self = this;

        this.searchField.on('keydown', this.keyPressDispatcher.bind(this));
        this.searchField.on('keyup', this.typingLogic.bind(this));

        // Prevent regular form submit
        this.searchForm.on('submit', function (e) {
            e.preventDefault();
        });

        this.searchButton.on('click', function (e) {
            e.preventDefault();

            if (self.searchField.val()) {
                window.location.href = ajax.site_url + "/?s=" + self.searchField.val();
            }
        });
    }

    // methods
    typingLogic() {
        if (this.searchField.val() != this.previousValue && this.searchField.val().length >= this.min_search_length) {
            clearTimeout(this.typingTimer);
            this.actionBox.hide();

            if (this.searchField.val()) {
                if (!this.isSpinnerVisible) {
                    this.searchResults.html('<div class="spinner-loader mx-auto d-block"><div></div><div></div><div></div><div></div></div>');
                    this.isSpinnerVisible = true;
                }
                this.typingTimer = setTimeout(this.getResults.bind(this), 750);
            } else {
                this.searchResults.html('');
                this.isSpinnerVisible = false;
            }
        }

        this.previousValue = this.searchField.val();
    }

    getResults() {
        this.actionBox.hide();
        this.searchResults.css('margin-bottom', '0px');

        this.openOverlay();

        var self = this;

        var post_data = {
            action: 'gpa_livesearch',
            query: this.previousValue,
            nonce: ajax.nonce
        };

        $.post(ajax.url, post_data, function (response) {
            var resultsDiv = `<h5 class="text-center text-primary my-4">${response.no_results_text}</h5>`;

            if (response.results && response.post_count) {
                self.actionBox.fadeIn();
                self.searchResults.css('margin-bottom', self.actionBox.outerHeight() + 'px');

                resultsDiv = '';

                for (const [key, value] of Object.entries(response.results)) {
                    if (!value.data.hits) {
                        continue;
                    }

                    resultsDiv += `<h5 class="text-gray-1 mb-3">${value.data.title}</h5>`;
                    resultsDiv += `<div class="row no-gutters">${value.html}</div>`;
                }
            }

            self.searchResults.html(resultsDiv);
            self.isSpinnerVisible = false;
        });
    }

    keyPressDispatcher(e) {
        if (83 == e.keyCode && !this.isOverlayOpen && !$('input, textarea').is(':focus')) {
            this.openOverlay();
        }

        if (27 == e.keyCode) {
            this.closeOverlay();
        }

        if (13 == e.keyCode) {
            this.closeOverlay();
            this.searchRedirect();
        }

    }

    searchRedirect() {
        let val = this.searchField.val();
        console.log(val);
        if (val) {
            window.location.href = '/?s=' + this.searchField.val();
        }
    }

    openOverlay() {
        this.searchOverlay.addClass('overlay--active');
        $('body').addClass('body-no-scroll');
        setTimeout(() => this.searchField.focus(), 301);
        this.isOverlayOpen = true;


        $(document).on('click', (e) => {
            if (!$(e.target).closest('.overlay--active').length) {
                $('body').removeClass('body-no-scroll');
            }
        });

        return false;
    }

    closeOverlay() {
        this.searchOverlay.removeClass('overlay--active');
        $('body').removeClass('body-no-scroll');
        this.isOverlayOpen = false;

        $(document).off('click');
    }
}

export default FloatingSearch;
